import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const IpWarmingPlanView = lazy(() =>
  import("@scenes/IpWarming").then((module) => ({
    default: module.IpWarmingPlanView,
  }))
);

/**
 * Status-driven IP warming plan view. Registered at both
 * `/app_settings/app_settings/email_settings/ip_warming/new/:appGroupId` (new wizard) and
 * `/app_settings/app_settings/email_settings/ip_warming/:planId/:appGroupId` (render by status).
 * Gated behind the `multiple_ip_warming_plans` flipper: with it off, `getDeveloperNavigationAllowed`
 * returns false, so these routes are not navigable and BrazeRoute redirects to the homepage.
 */
export const ipWarmingPlanNRO: NavigationRoutingObject = {
  section: "settings",
  Component: IpWarmingPlanView,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) => t("ip-warming-nro-heading", "Automated IP Warming"),
  pageNameForTracking: () => "Automated IP Warming",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("automated_ip_warming") && featureOn("multiple_ip_warming_plans");
  },
  showInSearchResults: false,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  // Point at the base route (only an :appGroupId param) so workspace-switch URL generation, which
  // only substitutes :appGroupId, produces a valid path rather than a literal :planId segment.
  defaultRoute: "/app_settings/app_settings/email_settings/ip_warming/:appGroupId",
};
